module.exports = __webpack_public_path__ + "27cb86ffe415d9e51bfdfcc70f585fb5.pdf";